import React from "react";

import Grid from "@material-ui/core/Grid";

import PageLoadingIndicator from "../../../../RiskProfiling/components/PageLoadingIndicator";
import {LOADING_MSG, SERVER_ERROR} from "../../../constants";
import ErrorMessage from "../../../../CustomerDashboardV2/components_v2/ChartSectionBordered/components/ErrorMessage";

const ContractDetailsLoader = ({fetchState, children}) => {

  if(fetchState.loading) {
    return (
      <Grid item xs={12} style={{'--preloader-padding-top': 0}}>
        <PageLoadingIndicator loadingMsg={LOADING_MSG} />
      </Grid>
    );
  } else if(!!fetchState.error){
    return (
      <Grid item xs={12}><ErrorMessage error={SERVER_ERROR} withPadding /></Grid>
    )
  }

  return children;
};

export default ContractDetailsLoader;